// import { resolve } from 'core-js/fn/promise'
// import { resolve } from 'core-js/fn/promise'
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 解决重复点击路由报错的BUG
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err)
}

export default new VueRouter({
    routes: [
        {
            path: "/",
            redirect: '/index'
        },
        {
            path: "/index",
            component: resolve => require(['@/views/index'], resolve),
            meta: { title: '网站首页' }
        },
        {
            path: "/grade",
            component: resolve => require(['@/views/grade/index'], resolve),
            meta: { title: '成绩查询' }
        },
        {
            path: "/login",
            component: resolve => require(['@/views/login/index'], resolve),
            meta: { title: '登录' }
        },
        {
            path: "/notice",
            component: resolve => require(['@/views/notice/index'], resolve),
            meta: { title: '招考公告', showfater: true },
            children: [
                {
                    path: "detail",
                    component: resolve => require(['@/views/notice/detail'], resolve),
                    meta: { title: '招考公告详情', showfater: false },
                },
                {
                    path: "apply",
                    component: resolve => require(['@/views/notice/apply'], resolve),
                    meta: { title: '立即报名', showfater: false },
                },
            ]
        },
        {
            path: "/public-announcement",
            component: resolve => require(['@/views/public-announcement/index'], resolve),
            meta: { title: '公示公告', showfater: true },
            children: [
                {
                    path: "detail",
                    component: resolve => require(['@/views/public-announcement/detail'], resolve),
                    meta: { title: '公示公告详情', showfater: false },
                },
            ]
        },
        {
            path: "/apply",
            component: resolve => require(['@/views/apply/index'], resolve),
            meta: { title: '报名流程', showfater: true },
            children: [
                {
                    path: "ticket",
                    component: resolve => require(['@/views/apply/admission-ticket'], resolve),
                    meta: { title: '打印准考证', showfater: false },
                },
            ]
        },
        {
            path: "/mine",
            component: resolve => require(['@/views/mine/index'], resolve),
            meta: { title: '个人中心' },
            redirect:'/mine/myapply',
            children:[
                {
                    path:"myapply",
                    component:resolve => require(['@/views/mine/my-apply'],resolve),
                    meta:{title:'我的报名'},
                },{
                    path:"myapplydetail",
                    component:resolve => require(['@/views/mine/my-apply-detail'],resolve),
                    meta:{title:'我的报名详情'},
                }, 
                {
                    path:"baseInfo",
                    component:resolve => require(['@/views/mine/baseInfo'],resolve),
                    meta:{title:'个人资料'},
                },
                {
                    path:"updatePwd",
                    component:resolve => require(['@/views/mine/update-pwd'],resolve),
                    meta:{title:'修改密码'},
                },
                {
                    path:"exit",
                    component:resolve => require(['@/views/mine/exit'],resolve),
                    meta:{title:'退出登录'},
                },
            ]
        },
        {
            path: "/ticket",
            component: resolve => require(['@/views/print-ticket/index'], resolve),
            meta: { title: '打印准考证' }
        }

        // {
        //     path:"/recruit",
        //     component:resolve => require(['@/views/recruit'],resolve),
        //     meta:{title:'人才招聘',showfater: true},
        //     children:[
        //         {
        //             path:"details",
        //             component:resolve => require(['@/views/recruit/details'],resolve)
        //         },
        //     ]
        // },
    ],
    mode: "history",
    // base:'/'
})